module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Recherche":"Search","Annuler":"Cancel","Faire une demande d\u0027admission":"Apply for admission","Connexion à mon dossier":"Connect to my file","https://admission.sram.qc.ca/mon-dossier":"https://admission.sram.qc.ca/my-file"}}')
  delete Component.options._Ctor
}
